import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
    DateField,
    EditButton,
    ShowButton,
    ListButton,
    CardActions,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import LinkToCreate from './LinkToCreate'
import BoolNumField from '../controls/PureBoolNumField'
import ErrorBoundary from '../ErrorBoundary';


const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const Editable = ({record}) => {
    console.log(record.editable);
    return <EditButton  record={record} label='Update'/>
    //return record && record.editable > 0 ? <EditButton  record={record} label='Update'/> : '';
}


const PhysicalActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <LinkToCreate ssn={props.filterValues.ssn} />
        <ListButton basePath={'/donors'} label="Donors List" />
    </CardActions>
);

export const PhysicalList = ({ classes, ...props }) => (
    <ErrorBoundary>
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<PhysicalActions/>} 
        title="Physical Exam"
        >
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="type"     label="Type" />   
            <BoolNumField source="suitable"  label="Is Suitable?" />  
            <DateField source="created_date"    label="Date" locales="en-us"/>
            <ShowButton />
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 3  &&  <Editable />}
           
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default withStyles(listStyles)(PhysicalList)